"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MESSAGE_ON_LOAD_IDS = exports.MESSAGE_ON_LOAD_URL_PARAM = exports.AUTH_TOKEN_EXPIRATION_DAYS = exports.AUTH_TOKEN_CREATOR_KEY = exports.AUTH_TOKEN_KEY = void 0;
exports.AUTH_TOKEN_KEY = 'acci_jwt';
exports.AUTH_TOKEN_CREATOR_KEY = 'acci_jwt_creator';
exports.AUTH_TOKEN_EXPIRATION_DAYS = 7;
exports.MESSAGE_ON_LOAD_URL_PARAM = 'acci_message_id';
exports.MESSAGE_ON_LOAD_IDS = {
    errorForceReload: '128',
};
//# sourceMappingURL=constants.js.map